<div [formGroup]="formGroup" class="searchable-select-container">
  <mat-form-field class="w-full" [appearance]="appearance">
    <mat-label>{{ label }}</mat-label>
    <mat-select #select [formControlName]="controlName" [multiple]="multiple" (selectionChange)="onOptionSelected()">
      <!-- Search Input Header -->
      <div class="search-header">
        <mat-form-field class="w-full no-subscript" appearance="outline">
          <input
            #searchInput
            matInput
            [placeholder]="placeholder"
            [formControl]="searchControl"
            (keydown)="handleKeydown($event)"
            autocomplete="off" />
          <button
            *ngIf="searchControl.value"
            matSuffix
            mat-icon-button
            aria-label="Clear"
            (click)="clearSearch($event)"
            type="button">
            <mat-icon>close</mat-icon>
          </button>
        </mat-form-field>
      </div>

      <!-- Options -->
      <mat-option *ngFor="let option of filteredOptions" [value]="option[valueKey]">
        {{ option[labelKey] }}
      </mat-option>

      <!-- Hidden selected options: kept in the DOM so the selection is not lost while filtering -->
      <mat-option
        *ngFor="let option of hiddenSelectedOptions"
        [value]="option[valueKey]"
        class="hidden-selected-option">
        {{ option[labelKey] }}
      </mat-option>

      <!-- No Results -->
      <mat-option *ngIf="filteredOptions.length === 0" disabled>No results found</mat-option>
    </mat-select>
  </mat-form-field>
</div>
